import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import outline from "../../assets/icons/home_treat.svg";
import google from "../../assets/icons/google_5968863.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./HomeSwiper.css";

const HomeReviews = () => {
  const testimonials = [
    {
      id: 1,
      name: "Rahul Sharma",
      feedback:
        "The doctors and staff were incredibly caring. The treatment process was smooth and professional.",
    },
    {
      id: 2,
      name: "Priya Reddy",
      feedback:
        "Very clean hospital with advanced equipment. I felt comfortable throughout my visit.",
    },
    {
      id: 3,
      name: "Anjali Verma",
      feedback:
        "Excellent patient care and friendly staff. Highly recommended for quality healthcare services.",
    },
    {
      id: 4,
      name: "Kiran Kumar",
      feedback:
        "Quick diagnosis and excellent support from the medical team. Truly satisfied with the experience.",
    },
    {
      id: 5,
      name: "Rahul Sharma",
      feedback:
        "The doctors and staff were incredibly caring. The treatment process was smooth and professional.",
    },
    {
      id: 6,
      name: "Priya Reddy",
      feedback:
        "Very clean hospital with advanced equipment. I felt comfortable throughout my visit.",
    },
    {
      id: 7,
      name: "Anjali Verma",
      feedback:
        "Excellent patient care and friendly staff. Highly recommended for quality healthcare services.",
    },
    {
      id: 8,
      name: "Kiran Kumar",
      feedback:
        "Quick diagnosis and excellent support from the medical team. Truly satisfied with the experience.",
    },
  ];

  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative ">
      <div className="md:top-20 bottom-0 left-10  absolute">
        <img src={outline} alt="outline" className="pointer-events-none" />
      </div>
      <div data-aos="fade-up" className=" mx-auto xl:max-w-[1280px] w-11/12 flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          testimonials
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          Trusted by Patients & Families
        </h2>
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          centeredSlides={true}
          pagination={{
            el: ".custom-swiper-pagination",
            clickable: true,
          }}
          loop={true}
          spaceBetween={30}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1.5,
            },
            769: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className=" xl:mt-28 lg:mt-20 md:mt-16 mt-12 mb-10"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={`${item.name}-${index}`}>
              {({ isActive }) => (
                <div className="w-full shadow-[0px_12px_37.1px_0px_#d2ab802e] group bg-almond  rounded-md z-10  xl:p-[40px_40px_30px_40px] p-8 flex flex-col">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="33"
                    viewBox="0 0 46 33"
                    fill="red"
                  >
                    <g clipPath="url(#clip0_900_433)">
                      <path
                        d="M9.34276 32.8571C9.27489 32.8571 9.20702 32.8478 9.14149 32.8292C8.8349 32.7408 8.62427 32.4617 8.62427 32.1431V18.2602H0.718494C0.320631 18.2602 0 17.9392 0 17.5461V0.714033C0 0.320966 0.322971 0 0.718494 0H18.6879C19.0857 0 19.4064 0.320966 19.4064 0.714033V17.5322C19.4064 17.6671 19.3689 17.7997 19.294 17.9136L9.95126 32.5245C9.8202 32.7315 9.59084 32.8571 9.34276 32.8571ZM1.43699 16.8181H9.34276C9.74063 16.8181 10.0613 17.1391 10.0613 17.5322V29.6754L17.967 17.3229V1.42807H1.43699V16.8181Z"
                        fill="#B87333"
                      />
                      <path
                        d="M35.9365 32.8571C35.8686 32.8571 35.8008 32.8478 35.7352 32.8292C35.4287 32.7408 35.218 32.4617 35.218 32.1431V18.2602H27.3122C26.9144 18.2602 26.5938 17.9392 26.5938 17.5461V0.714033C26.5938 0.31864 26.9167 0 27.3122 0H45.2816C45.6795 0 46.0001 0.320966 46.0001 0.714033V17.5322C46.0001 17.6671 45.9627 17.7997 45.8878 17.9136L36.545 32.5245C36.4139 32.7315 36.1846 32.8571 35.9365 32.8571ZM28.0307 16.8181H35.9365C36.3344 16.8181 36.655 17.1391 36.655 17.5322V29.6754L44.5608 17.3229V1.42807H28.0307V16.8181Z"
                        fill="#B87333"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_900_433">
                        <rect width="46" height="32.8571" fill="black" />
                      </clipPath>
                    </defs>
                  </svg>
                  <h3 className="mb-[15px] md:text-2xl text-xl font-bold text-matcha">
                    {item.name}
                  </h3>
                  <p className="text-base xl:leading-[26px] leading-tight text-matcha">
                    {item.feedback}
                  </p>
                  <div className="mt-5 relative flex justify-between items-center after:absolute after:h-[1px] after:w-full after:top-1/2 after:right-0 after:-z-0 after:bg-[#B87333]"></div>
                  <div className="flex justify-between items-center mt-3">
                    <img src={google} alt="" className="w-auto" />
                    <span>⭐⭐⭐⭐⭐</span>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-swiper-pagination w-full flex justify-center items-center"></div>
      </div>
    </div>
  );
};

export default HomeReviews;
